var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('scoreBoard'),_c('cardGrid',{staticClass:"m-game_grid"}),_c('controls',{staticClass:"m-game_controls"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }